/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import React from 'react';
import IconSuccess from 'assets/images/icon_success.svg';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { UpdateSaleState } from 'store/modules/update_sales_store/types';
import { Container } from './styles';

const CardBuySuccess = () => {
  const PAYMENT_METHOD_CARD = 'Cartão';
  const PAYMENT_METHOD_INVOICE = 'Boleto';
  const { update_sale } = useSelector<ApplicationState, UpdateSaleState>(
    (state) => state.session.update_sale,
  );
  return (
    <Container>
      <div className="row">
        <div className="col-md-12">
          <div
            className="card d-flex mx-auto justify-content-center align-items-center p-5 mt-5"
            style={{ width: '455px' }}
          >
            <img
              className="card-img-top mt-2"
              src={IconSuccess}
              alt="Imagem contato"
              style={{ width: '120px' }}
            />
            <div className="card-body">
              <h5 className="card-title card-title-text text-center">
                Parabéns! Sua compra foi <br /> realizada com sucesso.
              </h5>
              <p>
                Você adquiriu uma assinatura com os serviço(s)
                {update_sale?.services_name?.map((servicos) => ` ${servicos.nome}, `)}
              </p>
              <hr />
              <div className="row">
                <div className="col-md-6">
                  <p className="text-left">Valor final</p>
                </div>
                <div className="col-md-6">
                  <p className="text-right">
                    {` R$ ${parseFloat(update_sale?.sale?.venda?.valor_total)
                      .toFixed(2)
                      .replace('.', ',')}`}
                  </p>
                </div>
              </div>
              <hr className="mt-0" />
              <div className="row">
                <div className="col-md-6">
                  <p className="text-left">Forma de pagamento</p>
                </div>
                <div className="col-md-6">
                  <p className="text-right">
                    {update_sale?.sale?.venda?.formas_pagamento_id === 10
                      ? PAYMENT_METHOD_CARD
                      : PAYMENT_METHOD_INVOICE}{' '}
                    {`em ${update_sale?.sale?.venda?.parcelas} vezes`}
                  </p>
                </div>
              </div>
              <hr className="mt-0" />
              <div className="row">
                <div className="col-md-4">
                  <p className="text-left">Vigência</p>
                </div>
                <div className="col-md-8">
                  <p className="text-right">{`${update_sale?.vigencia_inicio} até ${update_sale?.vigencia_fim} `}</p>
                </div>
              </div>
              <a className="btn btn-primary text-center" href="/painel">
                Ir para painel
              </a>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CardBuySuccess;
